module.exports = __webpack_public_path__ + "static/media/friendly.480caced.jpg";